export default __webpack_public_path__ + "static/media/35.5fb04689.jpg";